// Thai is the main language; English is offered for visitors who do not read Thai.
// t('ไทย', 'English') returns the text for the chosen language. The choice is kept in the browser,
// and a link ending in ?lang=en (or ?lang=th) opens the site in that language.
const read = (k) => { try { return localStorage.getItem(k); } catch { return null; } };
const write = (k, v) => { try { localStorage.setItem(k, v); } catch { /* storage unavailable */ } };

try {
  const asked = new URLSearchParams(location.search).get('lang');
  if (asked === 'en' || asked === 'th') write('verispace.lang', asked);
} catch { /* no location */ }
const lang = read('verispace.lang') === 'en' ? 'en' : 'th';
document.documentElement.lang = lang;

export const getLang = () => lang;
export const t = (th, en) => (lang === 'en' && en != null ? en : th);
export const locale = () => (lang === 'en' ? 'en-GB' : 'th-TH');
// Labels and menus are built once when the page loads, so changing language reloads the page.
export function setLang(value) {
  write('verispace.lang', value === 'en' ? 'en' : 'th');
  const url = new URL(location.href); url.searchParams.delete('lang');
  location.replace(url.pathname + url.search + url.hash);
}

// First-visit choices made on the welcome screen.
export const prefs = {
  onboarded: () => read('verispace.onboarded') === '1',
  finish: (role) => { write('verispace.onboarded', '1'); if (role) write('verispace.role', role); },
  role: () => read('verispace.role'),
};

// Theme: light by default, dark when the user picks it. The device setting is not followed.
export const getTheme = () => (read('verispace.theme') === 'dark' ? 'dark' : 'light');
const themeListeners = new Set();
export const onThemeChange = (fn) => { themeListeners.add(fn); return () => themeListeners.delete(fn); };
export function setTheme(value) {
  const dark = value === 'dark';
  write('verispace.theme', dark ? 'dark' : 'light');
  if (dark) document.documentElement.setAttribute('data-theme', 'dark'); else document.documentElement.removeAttribute('data-theme');
  document.querySelector('meta[name="theme-color"]')?.setAttribute('content', dark ? '#0B1A2E' : '#F7F8FA');
  themeListeners.forEach((fn) => fn(dark ? 'dark' : 'light'));
}
